import React from 'react';
export const BonusValueSection = () => {
  return <section className="bg-biosync-bgTest py-10 px-5 sm:px-10" data-id="element-34">
      <div className="max-w-[1100px] mx-auto text-center" data-id="element-35">
        <div className="max-w-md mx-auto border-t border-b border-biosync/20 py-8" data-id="element-36">
          <p className="text-biosync-textSec text-base mb-2" data-id="element-37">
            Valor total de los 3 Bonos
          </p>
          <p className="text-red-500 font-bold text-3xl line-through mb-4" data-id="element-38">
            $45.000 ARS
          </p>
          <div className="inline-block bg-biosync text-white font-bold text-lg sm:text-xl py-3 px-6 rounded-xl mb-4 shadow-sm" data-id="element-39">
            🎁 GRATIS — Incluidos con tu compra hoy
          </div>
          <p className="text-biosync-textSec text-sm" data-id="element-40">
            En todas las compras del sistema BIO-SYNC.
          </p>
        </div>
      </div>
    </section>;
};